import { Heart } from "lucide-react";
import { useSaved } from "../context/SavedContext";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../i18n/I18nProvider";
import { toast } from "sonner";

export default function SaveButton({ listingId, size = 18, className = "" }) {
  const { user } = useAuth();
  const saved = useSaved();
  const { t } = useI18n();
  const isSaved = saved?.ids?.has(listingId);

  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      toast.error(t("saved.requireLogin"));
      return;
    }
    const res = await saved.toggle(listingId);
    if (res.ok) {
      toast.success(res.saved ? t("saved.addToast") : t("saved.removeToast"));
    }
  };

  return (
    <button
      onClick={onClick}
      className={`p-2 border border-[var(--ink-200)] bg-[var(--surface)] hover:border-[var(--ink)] ${className}`}
      data-testid={`save-btn-${listingId}`}
      aria-label="save"
    >
      <Heart
        size={size}
        strokeWidth={1.8}
        fill={isSaved ? "#C5533B" : "transparent"}
        color={isSaved ? "#C5533B" : "currentColor"}
      />
    </button>
  );
}
